import {
  type CtfCurrentUser,
  type CtfCurrentUserRoleKey,
  readCtfCurrentUserApplicationRoles,
} from "./lib/ctf-contract";

const CTF_TEACHER_WORKSPACE_ROLES = new Set<CtfCurrentUserRoleKey>([
  "ctf_admin",
  "ctf_manager",
  "ctf_teacher",
]);

type InitialState = {
  currentUser?: CtfCurrentUser | null;
  ctfUser?: CtfCurrentUser | null;
};

function resolveApplicationRoles(ctfUser: CtfCurrentUser | null | undefined) {
  if (!ctfUser) return [];
  return readCtfCurrentUserApplicationRoles(ctfUser);
}

export function canAccessCtfTeacherWorkspace(user: CtfCurrentUser | null | undefined) {
  if (!user) return false;
  return resolveApplicationRoles(user).some((role) => CTF_TEACHER_WORKSPACE_ROLES.has(role));
}

export default function access(initialState: InitialState | undefined) {
  const currentUser = initialState?.currentUser ?? null;
  const ctfUser = initialState?.ctfUser ?? null;
  const canAccessTeacherWorkspace =
    Boolean(currentUser && ctfUser) && canAccessCtfTeacherWorkspace(ctfUser);
  return {
    canAccessCtfAdmin: canAccessTeacherWorkspace,
    canAccessCtfTeacherWorkspace: canAccessTeacherWorkspace,
  };
}
